import {MutationTree} from 'vuex'
import {MutationTypes} from './types'
import {IAuthentificationStateModel} from './../../../interfaces'
import {Profile} from '@/services/types'

export type AuthentificationMutations<S = IAuthentificationStateModel> = {
    [MutationTypes.SET_AUTHENTIFICATION_DATA_LOADING](state: S, payload: boolean): void;
    [MutationTypes.HAS_AUTHENTIFICATION_ERROR](state: S, payload: boolean): void;
    [MutationTypes.SET_AUTHENTIFICATION_PROFILE](state: S, payload: Profile | null): void;
    [MutationTypes.SET_AUTHENTIFICATION_HELPER_TEXT](state: S, payload: string): void;
    [MutationTypes.SET_AUTHENTIFICATION_AUTHENTICATED](state: S, payload: boolean): void;
}

export const mutations: MutationTree<IAuthentificationStateModel> & AuthentificationMutations = {
    [MutationTypes.SET_AUTHENTIFICATION_DATA_LOADING](state, payload: boolean) {
        state.dataIsLoading = payload
    },
    [MutationTypes.HAS_AUTHENTIFICATION_ERROR](state, payload: boolean) {
        state.error = payload
    },
    [MutationTypes.SET_AUTHENTIFICATION_PROFILE](state, payload: Profile) {
        state.profile = payload
    },
    [MutationTypes.SET_AUTHENTIFICATION_HELPER_TEXT](state, payload: string) {
        state.helperText = payload
    },
    [MutationTypes.SET_AUTHENTIFICATION_AUTHENTICATED](state, payload: boolean) {
        state.authenticated = payload
    }     
}